<ng-container *ngFor="let key of params?.keyMapping">
    <div class="flex-wrapper" [ngClass]="{'without-margin': !hasContent(key, cellRenderData), 'margin-top-gap': key?.class == 'margin-top-gap'}">
        <!-- Profile image -->
        <img [src]="cellRenderData[key.profileImage]" alt="image" class="profile-image" *ngIf="key.profileImage && cellRenderData[key.profileImage]">
        <!--  Custom Icon -->
        <ng-container *ngIf="key.type == 'custom_icon' && key.iconsList[cellRenderData[key.iconKey]]">
            <span *ngIf="key.iconsList[cellRenderData[key.iconKey]]=='fa fa-check check-icon'">
            <img class="check-circle" *ngIf="key.iconImage" [src]="key.iconImage" alt="image"/>
            </span>
            <span class="icon" *ngIf="key.iconsList[cellRenderData[key.iconKey]]!='fa fa-check check-icon'">
                <i [class]="key.iconsList[cellRenderData[key.iconKey]]"></i>
            </span>
        </ng-container>

        <ng-container *ngIf="key.type == 'static_icon' && key.customTextList[cellRenderData[key.customTextKey]]">
            <i [class]="key.iconName" class="icon"></i>
        </ng-container>
        <!--  Text  -->
        <div *ngIf="key.text || key.customTextKey">
            <div *ngIf="key.text && cellRenderData[key.text]" translate [innerHTML]="cellRenderData[key.text]"></div>

            <div  *ngIf="key.additionalText && cellRenderData[key.additionalText] as value" translate>
                <ng-container *ngIf="isDateObject(value); else plainText">
                    {{ getUserDate(value.date) }}
                </ng-container>
                <ng-template #plainText>
                    {{ value }}
                </ng-template>
            </div>

            <!-- Custom text -->
            <div *ngIf="key.customTextKey" translate>{{ key.customTextList[cellRenderData[key.customTextKey]] }}</div>
        </div>

        <div class="tags-conatiner" *ngIf="key.type == 'tags'">
            <ng-container *ngFor="let tag of cellRenderData[key.tagsList]">
                <div class="tags" [ngStyle]="{'background': tag?.background, 'color': tag?.color}">{{tag?.name}}</div>
            </ng-container>
        </div>

        <!--  Right side icon -->
        <span class="right-side-icon" *ngIf="key.icon">
          <i [class]="getIconClass(cellRenderData[key.icon])"></i>
        </span>
    </div>
</ng-container>
